import React from 'react';
import { string, bool, oneOf } from 'prop-types';
import classnames from 'classnames';
import { Tooltip, Icon } from '@fiverr-private/fit';
import { EducationTooltip } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/fiverr_context';
import { s_info_circle } from '@fiverr-private/icons';
import sassVars from './style.scss';

const copyPrefix = 'gig_page_perseus.notableClients';

const TopClientsTitle = ({ sellerName, newBadge, educate, fontSize = '14', isWrapped }) => (
    <div className="notable-clients-title">
        <span className={`font-${fontSize}`}>
            <b><I18n k={`${copyPrefix}.top_clients`}/></b>
            &nbsp;
        </span>
        { educate ? (
            <EducationTooltip title={<I18n k={`${copyPrefix}.top_clients`}/>}
                body={<I18n k={`${copyPrefix}.welcome`} params={{ sellerName }}/>}
                boxClassName={classnames(
                    'notable-clients-education-box',
                    { 'm-t-12': isWrapped }
                )}
                badgeTitle={<I18n k={`${copyPrefix}.new`}/>}
                closeTitle={<I18n k={`${copyPrefix}.got_it`}/>}
                tooltipStorageKey="notableClients_bar_ed"
                position={EducationTooltip.POSITIONS.BOTTOM}>
                    &nbsp;
            </EducationTooltip>
        ) : (<>&nbsp;</>) }
        <Tooltip boxContentClassName="top-clients-tooltip-content"
            content={<I18n k={`${copyPrefix}.tooltip`} params={{ sellerName }}/>}>
            <Icon color={sassVars.grey_800} className="tooltip-icon">{s_info_circle}</Icon>
        </Tooltip>
        { newBadge && <span className="badge-new"><I18n k={`${copyPrefix}.new`}/></span>}
    </div>
);

TopClientsTitle.propTypes = {
    sellerName: string,
    newBadge: bool,
    educate: bool,
    fontSize: oneOf(['14', '16']),
    isWrapped: bool
};

export default TopClientsTitle;
